module.exports = {
  common: {
    ns: 'common',
    routeId: 48,
    isAsync: true,
  },
  home: {
    ns: 'home',
    routeId: 28,
    isAsync: true,
  },
  'cloud-market': {
    ns: 'cloud-market',
    routeId: 122,
    isAsync: true,
  },
  'portal-market': {
    ns: 'portal-market',
    routeId: 147,
    isAsync: true,
  },
  'portal-account': {
    ns: 'portal-account',
    routeId: 171,
    isAsync: true,
  },
  'portal-document': {
    ns: 'portal-document',
    routeId: 174,
    isAsync: true,
  },
  document: {
    ns: 'document',
    routeId: 30,
    isAsync: true,
  },
  'portal-operational': {
    ns: 'portal-operational',
    routeId: 205,
    isAsync: true,
  },
};
